<template>
  <div class="header">
    <el-row :class="[swiper ? '': 'header2']">
        <el-col :span="8" :offset='3'>
          <div class="header-title">
            <img src="../../assets/logo.png" alt="logo">
            <div>
              <div class="web-name font24">十堰市物流公共信息服务平台</div>
              <div>十堰市城市绿色货运配送示范工程信息网</div>
            </div>
          </div>
        </el-col>
        <el-col :span="4" :offset='9'>
          <div class="font16 login" @click="login">{{type==1?'登录/注册':username}}</div>
        </el-col>
    </el-row>
    <el-row v-if="swiper">
      <el-col :span="24" class="res">
        <img src="../../assets/header.png" alt="首图" class="swiper">
        <div class="pos">
            <span>{{day}}&nbsp;&nbsp;&nbsp;&nbsp;{{week}} &nbsp;&nbsp;</span>
            <span>{{time | fromaDate}}</span>
            <span>&nbsp;&nbsp;温度&nbsp;{{indexTips.temperature}}</span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import bus from '../../public/bus.js'
  export default {
    data() {
      return {
        swiper: false,
        type:1,
        username:'',
        indexTips:{},
        week:'',
        day:'',
        time:'',
        timer:null
      }
    },
    created() {
      this.swiper = this.$swiper == '/' ? true : false;
      bus.$on('pageChange', path => {
        this.swiper = path == '/' ? true : false;
      })
      if(localStorage.getItem('user')){
          this.type = 2;
          this.username = JSON.parse(localStorage.getItem('user')).ma002
      }
      // 获取获取天气
      AMap.plugin('AMap.Weather', ()=> {
          var weather = new AMap.Weather();
          //查询实时天气信息
          weather.getLive('十堰市', (err, data)=> {
              if (!err) {
               let sym = {
                  weather:data.weather,
                  temperature:data.temperature + '℃',
                  windDirection:data.windDirection+'风'+data.windPower+"级",
                }
              if(data.weather.indexOf('晴')){
                data.img = require('../../assets/sun.png')
              }else if(data.weather.indexOf('阴')){

              }else{

              }
               this.indexTips = sym;
              }
          });
      })
      this.initTime();
    },
    methods:{
      login(){
        window.open('http://manage.sywlfz.com','_blank')
      },
      initTime() {
          let date = new Date();
          let week = '';
          switch (date.getDay()) {
              case 1:
                  week = '一';
                  break;
              case 2:
                  week = '二';
                  break;
              case 3:
                  week = '三';
                  break;
              case 4:
                  week = '四';
                  break;
              case 5:
                  week = '五';
                  break;
              case 6:
                  week = '六';
                  break;
              case 7:
                  week = '日';
                  break;
          }
          this.week = '星期' + week;
          this.day = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() +'日';
          this.timer = setInterval(() => {
              this.time = new Date();
          }, 1000)
      },
    },
    filters:{
      fromaDate(time) {
          let date = new Date();
          let hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours();
          let minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes();
          let seconds = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds();
          return hours + ':' + minutes + ':' + seconds;
      }
    }

  }
</script>

<style scoped>
  .header {
    width: 100%;
    height: 17.2rem;
    background-color: #0083CE;
    font-size: 2.4rem;
    color: #FFFFFF;
  }
  .header2{
    background-image: url("../../assets/header_top.png") ;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .header-col {
    display: grid;
    align-items: center;
  }

  .header-title {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    height: 17.2rem;
  }

  .header-title>img {
    display: block;
    width: 7rem;
    height: 7rem;
    margin-right: 1rem;
  }

  .web-name {
    margin-bottom: 2.4rem;
    letter-spacing: 0.4rem;
  }

  .web-name+div {
    font-size: 2rem;
  }

  .login {
    height: 17.2rem;
    line-height: 17.2rem;
    cursor: pointer;
  }

  .swiper {
    display: block;
    width: 100%;
    height: 61.1rem;
  }

  .font16 {
    font-size: 1.6rem;
  }
  .res{
    position: relative;
  }
  .pos{
    position: absolute;
    left: 26rem;
    bottom: 2rem;
    color: #333333;
    font-size: 1.6rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue